import { useCallback, useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { useProductReadContext } from '@context/ProductContext'

import { CommonPaths } from '@utils/path'

import type { FundingLocationState } from './useFundingNav'

export const useFundingExit = () => {
  const navigate = useNavigate()
  const { pathname, state } = useLocation()
  const { isDefaultCFDProductType } = useProductReadContext()

  const isCFD = isDefaultCFDProductType()
  const isPA = pathname.includes('/payment-agent/')
  const isIB = pathname.includes('/introducing-broker/')
  const returnPath = (state as FundingLocationState | null)?.returnPath

  const exitRoute = useMemo(() => {
    if (isPA) return CommonPaths.PaymentAgentWallets
    if (isIB) return CommonPaths.IntroducingBrokerWallets
    return isCFD ? CommonPaths.TradersRoomWallets : CommonPaths.TradersRoomBalances
  }, [isPA, isIB, isCFD])

  const handleExit = useCallback(() => {
    navigate(returnPath ?? exitRoute)
  }, [navigate, returnPath, exitRoute])

  return { handleExit, exitRoute }
}
